// extracted by mini-css-extract-plugin
export var avatarContainer = "_9t-0";
export var avatarTypingWave = "_9t-i";
export var gray = "_9t-f";
export var green = "_9t-c";
export var icon = "_9t-9";
export var image = "_9t-1";
export var lg = "_9t-6";
export var md = "_9t-5";
export var presenceDot = "_9t-b";
export var red = "_9t-d";
export var sm = "_9t-4";
export var status = "_9t-a";
export var typingDot = "_9t-h";
export var typingPill = "_9t-g";
export var xl = "_9t-7";
export var xs = "_9t-3";
export var xxl = "_9t-8";
export var xxs = "_9t-2";
export var yellow = "_9t-e";